import * as React from 'react';
import './Loader.scss';
import { Translate, injectIntl } from "../../localization/index";

const Loader = () => {
  return (
    <div className="loading-container">
      <div className="lds-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};
export default Loader;
